<template>
<div id="apptable" v-cloak>

    <b-card :header="(this.$route.params.titolo != null ? 'Analisi risultati questionario ' + this.$route.params.titolo : 'Analisi risultati questionari')" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button size="md" variant="outline-secondary" @click.stop="exportCSV()">
                        Esporta CSV
                    </b-button>                    
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="(this.$route.params.titolo != null ? fields : fields2)" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="anno" scope="row">{{row.value}}</template>
                <template slot="tipologia" scope="row">{{row.value}}</template>
                <template slot="domanda" scope="row">{{row.value}}</template>
                <template slot="minimo" scope="row">{{row.value}}</template>
                <template slot="massimo" scope="row">{{row.value}}</template>
                <template slot="media" scope="row">{{row.value}}</template>
            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>
    
</div>
</template>

<script>

import moment from 'moment'

import {
    ctrlVismenu
} from '../util.js'

import {
    NAMESPACE
} from '../config.js'

export default {
    name: 'apptable',
    data: function () {
        return {            
            items: [],
            namespace: NAMESPACE,
            fields: {                                              
                tipologia: {
                    label: 'Tipo domanda',
                    sortable: true
                },  
                domanda: {
                    label: 'Domanda',
                    sortable: true
                },             
                minimo: {
                    label: 'Minimo',
                    sortable: true
                },    
                massimo: {
                    label: 'Massimo',
                    sortable: true
                }, 
                mediaVis: {
                    label: 'Media',
                    sortable: true
                }
            },
            fields2: {                              
                anno: {
                    label: 'Anno',
                    sortable: true
                },
                tipologia: {
                    label: 'Tipo domanda',
                    sortable: true
                },          
                minimo: {
                    label: 'Minimo',
                    sortable: true
                },    
                massimo: {
                    label: 'Massimo',
                    sortable: true
                }, 
                mediaVis: {
                    label: 'Media',
                    sortable: true
                }
            },
            id_scheda: this.$route.params.id_scheda || null,
            tipo: this.$route.params.tipo || null,
            titolo: this.$route.params.titolo || null,
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 5,
                value: 5
            }, {
                text: 10,
                value: 10
            }, {
                text: 15,
                value: 15
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,            
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        }
    },
    methods: {        
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        exportCSV() {
            if (this.items.length > 0) {
                var strAppo;
                if (this.id_scheda != null){
                    var str = '"Tipo domanda";"Domanda";"Minimo";"Massimo";"Media"\r\n';
                    for (var i = 0; i < this.items.length; i++) {
                        str += '"' + this.items[i].tipologia.replace(/\"/g, "\"\"") + '"' + ";";                      
                        str += '"' + this.items[i].domanda.replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + this.items[i].minimo + '"' + ";";
                        str += '"' + this.items[i].massimo + '"' + ";";
                        str += '"' + this.items[i].mediaVis + '"' + "\r\n";
                    }
                }
                else{
                    var str = '"Anno";"Tipo domanda";"Minimo";"Massimo";"Media"\r\n';
                    for (var i = 0; i < this.items.length; i++) {
                        str += '"' + this.items[i].anno + '"' + ";";                        
                        str += '"' + this.items[i].tipologia.replace(/\"/g, "\"\"") + '"' + ";";
                        str += '"' + this.items[i].minimo + '"' + ";";
                        str += '"' + this.items[i].massimo + '"' + ";";
                        str += '"' + this.items[i].mediaVis + '"' + "\r\n";
                    }

                }
                

                var a = document.createElement('a');
                var blob = new Blob([str], {
                    'type': 'application\/octet-stream'
                });

                a.href = window.URL.createObjectURL(blob);
                a.download = 'analisi_' + moment(String(new Date())).format('YYYYMMDD_HHmmss') + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function() {
                    document.body.removeChild(a);
                }, 100);
            }
        },
    },
    created: function () {

           
        
        if(!ctrlVismenu("E")&&!ctrlVismenu("I")){
            this.$router.replace('/accessdenied');
            return;
        }  

        var token = localStorage.getItem('token');
        var id_scheda = this.id_scheda;
        
        this.axios.get(NAMESPACE + 'rest/analisirisultati/' + id_scheda, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        apptable.items.forEach(function (element, index) {                            
                            element.mediaVis = (parseFloat(element.media).toFixed(2) == 'NaN' ? '' : parseFloat(element.media).toFixed(2));
                        });

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
